import { testimonials } from '@/mocks/news';

export default function TestimonialSection() {
  return (
    <section id="voices" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="font-label text-xs tracking-[0.25em] text-secondary-600">READER VOICES</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">读者怎么说</h2>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">
            「看料大瓜」的定位是帮你省时间。以下是读者的真实反馈节选。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {testimonials.map((item, idx) => (
            <figure
              key={item.name}
              className={`rounded-lg border border-background-200 bg-background-50 p-6 ${
                idx === 1 ? 'md:-translate-y-3' : ''
              }`}
            >
              <div className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className="ri-double-quotes-l text-lg" aria-hidden="true"></i>
              </div>
              <blockquote className="mt-4 text-sm leading-relaxed text-foreground-700">{item.quote}</blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-500 font-heading text-sm font-bold text-background-50">
                  {item.name.slice(0, 1)}
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-950">{item.name}</span>
                  <span className="block text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}